import "./about.css"

function About() {
  return (
    <div className="about-container">
      <div className="about-grid">
        <div className="about-info">
          <h3>About Me <img src="https://s2.loli.net/2025/04/28/pwgiB4FhSxlXKLk.png" width="25px" alt="icon" /> </h3>
          <p><b>ZACH DENG</b> / Based on Chicago</p>
          <p>Photographer | Software Engineer</p>
          <p>You can find me at IG @shotitblind / Rednote @瞎按快門 (ID: 497539155)</p>
          <p>For inquires, please contact:</p>

          <div className="links">
            <p>
              <img src="https://i.loli.net/2020/07/19/B4sGYjqAmCTVxgb.png" width="20px" alt="email"/> 
              <a href="mailto:zacdeng0720@email.com"><i>zacdeng0720@gmail.com</i></a>
            </p>
            <p>
              <img src="https://s2.loli.net/2022/06/03/Orq1ki4lMd2bDyo.png" width="20px" alt="ig"/> 
              <a href="https://www.instagram.com/shotitblind/"><i>@shotitblind</i></a>
            </p>
            <p>
              <img src="https://s2.loli.net/2025/04/20/nDgN7pZmxetS1PQ.png" width="20px" alt="rednotes"/> 
              <a href="https://www.xiaohongshu.com/user/profile/5df4a5420000000001001e59"><i>@瞎按快門</i></a>
            </p>
          </div>
          
          <p className="equipment"><b>EQUIPMENTS</b></p>
          <p><img src="https://s2.loli.net/2025/04/28/VWNFnxY5d12eBkH.png" width="25px" alt="35mm" />Leica M6 | Contax G2 | Minolta TC-1 | Konica Hexar AF | Pentax 17 | Rollei 35s</p>
          <p><img src="https://s2.loli.net/2025/05/21/9lO3dvGxmoj4Mzq.png" width="25px" alt="Medium Format" />Rolleiflex 2.8E | Mamiya 645</p>
          <p><img src="https://s2.loli.net/2025/04/28/zKGpHCcJMLnaTfD.png" width="25px" alt="Instant" />Fujifilm Instax Wide 300 | Mini 90</p>
          <p><img src="https://s2.loli.net/2025/04/28/NrCFDVEMRijPW8S.png" width="25px" alt="Digit" />Fujifilm xs20</p>
        </div>
        
        <div className="about-photo">
          <img src="https://s2.loli.net/2025/11/01/VkA1RITy2zb3gsl.jpg" alt="portfolio" />
        </div>
      </div>
    </div>




  );
}

export default About